/**
 * @generated SignedSource<<22610e81c38dcce4c4011b4703013ca0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuDrawer_itemSearch$data = {
  readonly pageType: string | null;
  readonly totalResults: number | null;
  readonly filters: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilters_filters" | "SbSharedRefineMenuDisplayPrefsSelect_filters">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilters_itemSearch" | "SbRespSortItems_itemSearch" | "SbSharedRefineMenuSearchWithin_itemSearch" | "SbRespRefineMenuDrawerHeader_itemSearch" | "SbRespRefineMenuFilterSortFacet_itemSearch" | "SbSharedRefineMenuDisplayPrefsSelect_itemSearch">;
  readonly " $fragmentType": "SbRespRefineMenuDrawer_itemSearch";
};
export type SbRespRefineMenuDrawer_itemSearch$key = {
  readonly " $data"?: SbRespRefineMenuDrawer_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuDrawer_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuDrawer_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespSortItems_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuSearchWithin_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuDrawerHeader_itemSearch"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalResults",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseFilter",
      "kind": "LinkedField",
      "name": "filters",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedRefineMenuFilters_filters"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedRefineMenuDisplayPrefsSelect_filters"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterSortFacet_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "378f0c6e62d6aba9346cd12c30e943e2";

export default node;
